import { Box, Typography } from "@mui/material";
import React from "react";
import SEO from "../components/SEO";
import { SX } from "../sx";
import { C } from "../tokens";

const ROWS_EDITEUR = [
  { label: "Nom", value: "Maxime Nicolaieff" },
  { label: "Statut", value: "Ostéopathe D.O.  Entrepreneur individuel" },
  { label: "SIREN", value: "851 441 774" },
  { label: "SIRET (siège)", value: "851 441 774 00011" },
  { label: "N° TVA intracommunautaire", value: "FR84851441774" },
  { label: "Inscription RNE", value: "Inscrit depuis le 20/06/2019" },
  { label: "Adresse", value: "8 Route de Mons, 31130 Balma" },
  { label: "Email", value: "nicolaieffmaxime@gmail.com" },
  { label: "Téléphone", value: "06 95 78 89 83" },
];

const ROWS_HEBERGEUR = [
  { label: "Hébergeur", value: "Infomaniak Network SA" },
  { label: "Adresse", value: "Rue Eugène-Marziano 25, 1227 Genève, Suisse" },
  { label: "Site", value: "infomaniak.com" },
];

const ROWS_DONNEES = [
  { label: "Collecte de données", value: "Aucune donnée personnelle n'est collectée via ce site." },
  { label: "Cookies", value: "Ce site n'utilise aucun cookie de traçage ou publicitaire." },
  { label: "Formulaires", value: "Ce site ne comporte aucun formulaire de collecte de données." },
];

const Section = ({ title, rows }) => (
  <Box>
    <Typography
      variant="h2"
      component="h2"
      sx={{
        fontSize: "1.3rem",
        fontWeight: 600,
        color: C.text,
        mb: "1.25rem",
        pb: ".75rem",
        borderBottom: `1px solid ${C.border}`,
      }}
    >
      {title}
    </Typography>
    <Box sx={{ width: "100%" }}>
      {rows.map((r, i) => (
        <Box
          key={r.label}
          sx={{
            display: { xs: "block", sm: "flex" },
            borderBottom:
              i < rows.length - 1 ? `1px solid ${C.border}` : "none",
            py: { xs: ".75rem", sm: 0 },
          }}
        >
          <Box
            sx={{
              width: { xs: "100%", sm: "180px" },
              flexShrink: 0,
              py: ".85rem",
              pr: "1rem",
              fontSize: { xs: ".72rem", sm: ".82rem" },
              fontWeight: { xs: 600, sm: 400 },
              color: C.textMuted,
              verticalAlign: "top",
              pb: { xs: ".2rem", sm: ".85rem" },
            }}
          >
            {r.label}
          </Box>
          <Box
            sx={{
              py: { xs: 0, sm: ".85rem" },
              fontSize: ".88rem",
              color: C.text,
              lineHeight: 1.6,
            }}
          >
            {r.value}
          </Box>
        </Box>
      ))}
    </Box>
  </Box>
);

const MentionLegal = () => (
  <>
    <SEO
      title="Mentions légales  Maxime Nicolaieff Ostéopathe"
      description="Mentions légales du site balma-osteopathe.fr  Maxime Nicolaieff, ostéopathe D.O. (SIRET 851 441 774 00011). Éditeur, hébergeur Infomaniak. Aucune collecte de données personnelles ni cookie."
      path="/mentions-legales"
      noIndex
    />
    <Box component="section" sx={SX.pageHeroSection}>
      <Box sx={{ ...SX.pageHeroInner, maxWidth: "760px" }}>
        <Box component="span" sx={SX.sectionLabel}>
          Mentions légales
        </Box>
        <Typography variant="h1" component="h1" sx={SX.displayTitle}>
          Informations <em>légales &amp; RGPD.</em>
        </Typography>
        <Typography sx={SX.pageHeroSub}>
          Conformément à la loi n°2004-575 du 21 juin 2004 pour la confiance
          dans l'économie numérique.
        </Typography>
      </Box>
    </Box>

    <Box
      sx={{
        maxWidth: "760px",
        mx: "auto",
        px: { xs: "1rem", md: "2.5rem" },
        pb: { xs: "4rem", md: "5rem" },
        display: "flex",
        flexDirection: "column",
        gap: "3rem",
      }}
    >
      <Section title="Éditeur du site" rows={ROWS_EDITEUR} />
      <Section title="Hébergement" rows={ROWS_HEBERGEUR} />
      <Section title="Données personnelles" rows={ROWS_DONNEES} />
    </Box>
  </>
);

export default MentionLegal;
